import { action } from 'typesafe-actions';
import { BeneficiaryCategory } from './types';
import { RothConversionActionTypes as act } from './actionTypes';

export const addNewRothFund = (fund) => {
  return action(`${act.ADD_NEW_ROTH_FUND}_FULFILLED`, { fund });
};

export const emptyNewFund = () => {
  return (dispatch: CallableFunction) => {
    dispatch(action(`${act.EMPTY_NEW_FUND}_FULFILLED`, null));
  };
};

export function selectConversionFund(agreementID, props, step) {
  return action(act.SELECT_CONVERSION_FUND, { agreementID, props, step });
}

export function deselectConversionFund(agreementID, step) {
  return action(act.DESELECT_CONVERSION_FUND, { agreementID, step });
}

/**
 * Batch Select funds by taking in fund map
 * @param fundsMap {Record<agreementId, Fund>}
 * @param step {number}
 * @returns {action}
 */
export function batchSelectConversionFund(fundsMap, step) {
  return action(act.BATCH_SELECT_CONVERSION_FUND, { fundsMap, step });
}

export function updateConversionFund(agreementID, props, step) {
  return action(act.UPDATE_CONVERSION_FUND, {
    agreementID,
    props,
    step,
  });
}

export function resetTransaction() {
  return action(act.RESET_TRANSACTION, {});
}

export function updateFundAllocationType(allocationType) {
  return action(act.UPDATE_FUND_ALLOCATION_TYPE, { allocationType });
}

export function updateTaxPercentage(taxPercentage) {
  return action(act.UPDATE_TAX_PERCENTAGE, { taxPercentage });
}

export function updateTaxOption(taxOption) {
  return action(act.UPDATE_TAX_OPTION, { taxOption });
}

export function updateTermsAndConditions(termsConditions) {
  return action(act.UPDATE_TERMS_AND_CONDITIONS, { termsConditions });
}

/**
 * Used to adjust step 2 when user comes from step 1 with an allocation type selection
 * @param allocationType {string}
 */
export function adjustForRothAllocation(allocationType) {
  return action(act.ADJUST_FOR_ROTH_ALLOCATION, { allocationType });
}

/**
 * Trigger action for clicking Total Available for a To Fund in step 2
 * @param agreementID {string}
 * @param props {object}
 * @returns {action}
 */
export function updateFundAllocateTotalAvailable(agreementID, props) {
  return action(act.UPDATE_FUND_ALLOCATE_TOTAL, {
    agreementID,
    props,
  });
}

/**
 * Trigger action when user selects first "same fund" allocation option
 * in step 1 to skip step 2
 * collects all step one funds and converts them into the allocateTo object
 * @param existingRothIRAFunds {Fund[]}
 * @returns {action}
 */
export function skipRothAllocateToStep(existingRothIRAFunds) {
  return action(act.ROTH_CONVERSION_SKIP_STEP_2, {
    existingRothIRAFunds,
  });
}

/**
 * Action for beneficiary selection option (existing. new, etc)
 * @param beneficiaryOption string
 * @returns {action}
 */
export function updateRothBeneficiaryOption(
  beneficiaryOption,
  beneficiaries = [],
  i
) {
  return action(act.UPDATE_ROTH_BENEFICIARY_OPTION, {
    beneficiaryOption,
    beneficiaries,
    i,
  });
}

/**
 * Action for adding new user beneficiary (will add to user added beneficiary map)
 * @param id number
 * @param category string
 * @returns {action}
 */
export function addRothBeneficiary(id, category: BeneficiaryCategory) {
  return action(act.ADD_ROTH_BENEFICIARY, {
    id,
    category,
  });
}

/**
 * Action for deleting beneficiary from the user added beneficiary map
 * @param id number
 * @param category string
 * @returns {action}
 */
export function deleteRothBeneficiary(id, category: BeneficiaryCategory) {
  return action(act.DELETE_ROTH_BENEFICIARY, {
    id,
    category,
  });
}

/**
 * Action for updating a beneficiary from the user added beneficiary map
 * @param id number
 * @param category string
 * @returns {action}
 */
export function updateRothBeneficiary({ id, category, props }) {
  return action(act.UPDATE_ROTH_BENEFICIARY, {
    id,
    category,
    props,
  });
}
